// extracted by mini-css-extract-plugin
export var attachmentContainer = "_rz-0";
export var fileList = "_rz-2";
export var removeFileButton = "_rz-1";